module.exports = __webpack_public_path__ + "static/img/default_avatar.df2fa6de.png";